'use strict';

function decode(val) {
    try {
        return decodeURIComponent(val);
    } catch (err) {
        return val;
    }
}

function parseYCookie(cookie) {
    if (!cookie || typeof cookie !== 'string' || !cookie.length) {
        return {};
    }

    if (/%23\d{10}/.test(cookie)) {
        //fix of encoded # => %23 in YP-cookie
        cookie = decode(cookie);
    }

    cookie = cookie.split('#');

    var now = Date.now() / 1000,
        result = {},
        item;

    for (var i = 0, l = cookie.length; i < l; i++) {
        item = cookie[i].split('.');

        if (item.length === 2) {
            result[item[0]] = decode(item[1]);
        } else if (item.length > 2) {
            if (!isNaN(item[0])) {
                if (item[0] > now) {
                    result[item[1]] = {
                        value: decode(item.slice(2).join('.')),
                        expires: new Date(+(item[0] + '000'))
                    };
                }
            } else {
                result[item[0]] = decode(item.slice(1).join('.'));
            }
        }
    }

    return result;
}

function stringifyYCookie(data) {
    if (!data || typeof data !== 'object') {
        return;
    }

    var cookie = [],
        item,
        value;

    for (var i = 0, keys = Object.keys(data), l = keys.length; i < l; i++) {
        item = data[keys[i]];

        value = [
            keys[i],
            encodeURIComponent(item.value || item)
        ];

        if (/\d+/.test(item.expires)) {
            value.unshift(item.expires);
        }

        cookie.push(value.join('.'));
    }

    return cookie.join('#');
}

exports.parse = parseYCookie;
exports.stringify = stringifyYCookie;
